export default class Pagination {
  constructor () {
    this.data = []
    this.currentPage = 0
    this.firstPageUrl = null
    this.nextPageUrl = null
    this.lastPageUrl = null
    this.lastPage = 0
    this.perPage = 50
    this.hasMorePages = false
    this.total = null
  }

  setPagination (response) {
    this.currentPage = response.current_page
    this.firstPageUrl = response.first_page_url
    this.lastPage = response.last_page
    this.lastPageUrl = response.last_page_url
    this.nextPageUrl = response.next_page_url
    this.prevPageUrl = response.prev_page_url
    this.perPage = response.per_page
    this.total = response.total

    if (response.next_page_url) {
      this.hasMorePages = response.current_page !== response.last_page
    } else {
      this.hasMorePages = false
    }
  }
}
